import { APP_ROUTES } from "../router/constants";

export const brandPagesRoutes = [
  APP_ROUTES.translations,
  APP_ROUTES.customers,
  APP_ROUTES.quiz,
];

export const globalPagesRoutes = [
  APP_ROUTES.dashboard,
  APP_ROUTES.actionLogs,
  APP_ROUTES.accounts,
  APP_ROUTES.accountCreate,
  APP_ROUTES.roles,
  APP_ROUTES.brandsCreate,
];

export const isBrandRoute = (pathname: string) =>
  brandPagesRoutes.includes(pathname);

export const isGlobalRoute = (pathname: string) =>
  globalPagesRoutes.includes(pathname);
